import type { CategoriesApi } from '@/v2/api/metadata/categories'
import type { SportsApi } from '@/v2/api/metadata/sports'
import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import type { BackofficeContext } from '@/v2/framework/context/types'
import { createAddDialog } from './add'
import { createDeleteDialog } from './delete'
import { createEditDialog } from './edit'

export function createDialogs(options: {
  ctx: BackofficeContext
  roundsApi: TournamentRoundsApi
  sportsApi: SportsApi
  categoriesApi: CategoriesApi
  tournamentsApi: TournamentsApi
}) {
  return {
    add: createAddDialog(options),
    delete: createDeleteDialog(options),
    edit: createEditDialog(options),
  }
}
